import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";
export function configIndex(data){//配置
	return request.get(config.baseApi+"/data/api.config/index",data)
}
export function configCompany(data){//关于我们
	return request.get(config.baseApi+"/data/api.config/company",data)
}
export function messageIndex(data){//通知公告
	return request.get(config.baseApi+"/data/api.message/index",data)
}
export function homeChannel1(data){//招标公告
	return request.get(config.baseApi+"/data/api.home/channel1",data)
}
export function homeChannel2(data){//中标公告
	return request.get(config.baseApi+"/data/api.home/channel2",data)
}
export function homeChannel3(data){//更正公告
	return request.get(config.baseApi+"/data/api.home/channel3",data)
}
export function homeChannel4(data){//下载中心
	return request.get(config.baseApi+"/data/api.home/channel4",data)
}
export function homeChannel5(data){//电子竞价平台栏目
	return request.get(config.baseApi+"/data/api.home/channel5",data)
}
export function helpList(data){//帮助中心列表
	return request.get(config.baseApi+"/data/api.help/list",data)
}
export function helpDetail(data){//帮助中心详情
	return request.get(config.baseApi+"/data/api.help/detail",data)
}
export function projectTenderType(data){//招标专区类型
	return request.get(config.baseApi+"/data/api.projectTender/type",data)
}
export function projectTenderIndex(data){//招标专区列表
	return request.get(config.baseApi+"/data/api.projectTender/index",data)
}
export function projectTenderDetail(data){//招标专区详情
	return request.get(config.baseApi+"/data/api.projectTender/detail",data)
}
export function projectLawIndex(data){//法律法规列表
	return request.get(config.baseApi+"/data/api.projectLaw/index",data)
}
export function projectLawDetail(data){//法律法规详情
	return request.get(config.baseApi+"/data/api.projectLaw/detail",data)
}

export function projectBidType(data){//电子竞价平台类型
	return request.get(config.baseApi+"/data/api.projectBid/type",data)
}
export function projectBidIndex(data){//电子竞价平台列表
	return request.get(config.baseApi+"/data/api.projectBid/index",data)
}
export function projectBidDetail(data){//电子竞价平台详情
	return request.get(config.baseApi+"/data/api.projectBid/detail",data)
}

export function projectDownloadType(data){//下载专区类型
	return request.get(config.baseApi+"/data/api.projectDownload/type",data)
}
export function projectDownloadIndex(data){//下载专区列表
	return request.get(config.baseApi+"/data/api.projectDownload/index",data)
}

export function serviceIndex(data){//服务栏目
	return request.get(config.baseApi+"/data/api.service/index",data)
}
export function projectBusinessDetail(data){//业务范围
	return request.get(config.baseApi+"/data/api.ProjectBusiness/detail",data)
}
export function projectProcessDetail(data){//业务流程
	return request.get(config.baseApi+"/data/api.ProjectProcess/detail",data)
}

export function homeSearch(data){//搜索
	return request.get(config.baseApi+"/data/api.home/search",data)
}
export function sliderData(data){//友情链接
	return request.get(config.baseApi+"/data/api.data/getSlider",data)
}

export function messageDetail(data){//通知详情
	return request.get(config.baseApi+"/data/api.message/detail",data)
}